import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "How fast are payouts?",
    a: "Payout speed depends on the gift card brand and method. Most transactions complete within 60 minutes to 24 hours after our review step. Digital methods (PayPal, Cash App, Zelle, Apple Pay, Google Pay, Interac) are typically 1–6 hours; bank transfers and crypto can take up to 24 hours."
  },
  {
    q: "What gift cards do you accept?",
    a: "We accept 45+ brands across Retail, Gaming, Fashion, Tech, Beauty, Travel, and Prepaid categories. Browse the full list on the Brands section of our homepage."
  },
  {
    q: "What countries do you operate in?",
    a: "Giftopay is currently available in the United States, United Kingdom, United Arab Emirates, and Canada. More countries coming soon."
  },
  {
    q: "How are exchange rates calculated?",
    a: "Rates depend on the brand, country, card condition (new vs used), and current market demand. Once you submit a transaction, your rate is locked for 5 minutes."
  },
  {
    q: "Is it safe to share my card details?",
    a: "Yes. We use 256-bit SSL encryption in transit and AES-256 at rest. Card numbers are masked in our database; we never expose the full number after verification."
  },
  {
    q: "What happens if my card is rejected?",
    a: "If a card fails verification (zero balance, fraud flag, region mismatch), you'll receive an in-app notification and a clear explanation from our admin team."
  },
  {
    q: "Do I need to complete KYC?",
    a: "Most sellers can transact without KYC. For higher volumes or risk-flagged transactions, we may request ID verification to comply with AML regulations."
  },
  {
    q: "How does the referral program work?",
    a: "You earn 1% commission on every transaction completed by users you refer, for life. Find your referral link in your dashboard."
  },
  {
    q: "What if I have a problem with a transaction?",
    a: "Reach out via the WhatsApp button, email support@giftopay.com, or use the live chat. Most issues are resolved within 24 hours."
  },
  {
    q: "Are there any hidden fees?",
    a: "No. We charge a flat 2% processing fee that is clearly shown before you submit. Network fees may apply for crypto payouts and are displayed upfront."
  }
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="min-h-screen bg-white py-16" data-testid="faq-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#00C853] font-semibold">FAQ</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#0B3C5D] tracking-tight mt-3">
            Questions, answered.
          </h1>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => (
            <div key={i} className="rounded-2xl border border-slate-200 bg-white overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full text-left px-5 py-4 flex items-center justify-between hover:bg-slate-50"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-display font-semibold text-[#0B3C5D]">{f.q}</span>
                <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-sm text-slate-600 leading-relaxed">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
